import React from "react";
import { EasyBefore, m12 } from "../../constant/Index";
import "../../assets/Css/Style.css";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";
import "../../assets/Css/Profile.css";
import ProfileTab from "./ProfileTab";
import { useGetInterestQuery } from "../../store/services/InterestService";
import { useSiteSettingsQuery } from "../../store/services/HomeServices";
import { useSiteSettingUrlQuery } from "../../store/services/SiteSettingServices";
import Spinner from "../../utils/Loader";

const MyInterests = () => {
	let { data, isFetching } = useGetInterestQuery();

	const { data: Response, isFetching: load } = useSiteSettingsQuery();
	const { data: ImageUrl, isFetching: ImageLoad } = useSiteSettingUrlQuery();

	let navigate = useNavigate();

	return (
		<>
			{!isFetching ? (
				<>
					<div className="services Account">
						{/* Header */}
						<Header />
						{/* Header */}

						{/* Easy Plan Sec Start Here */}
						<section className="easy-plan mt-5">
							<div className="right-before">
								<figure>
									<img src={EasyBefore} alt="" className="img-fluid" />
								</figure>
							</div>
							<div className="container mt-5">
								<div className="row mb-3">
									<div className="col-lg-12 text-left">
										<p>
											Home{" "}
											<span className="fa fa-chevron-right chevron_right">
												{" "}
											</span>{" "}
											Profile
										</p>
									</div>
								</div>
							</div>
						</section>

						{/* accout section starts*/}
						<section className="profile_section">
							<div className="container">
								<div className="row">
									<div className="col-lg-3">
										<ProfileTab />
									</div>
									<div className="col-lg-9">
										<div className="InfoDetails">
											<h3 className="heading_Account">My Interest</h3>
											<div className="account">
												<div
													className="InnerDivScrol"
													style={{ height: "296px" }}
												>
													<div className="row">
														{data?.response?.data?.map((item, index) => {
															console.log(item, "sddsd");
															return (
																<>
																	<div className="col-lg-7 col-md-8 mt-3 my-0 my-lg-2 my-md-2">
																		<div className="d-flex" key={index}>
																			<img
																				className="product_img mr-4"
																				src={`${ImageUrl?.uploads}${item?.vehicle?.image}`}
																				alt="product"
																			/>
																			<div>
																				<h4 className="subheading_Account">
																					{item?.vehicle?.title}
																				</h4>
																				<p>{item?.vehicle?.description}</p>
																			</div>
																		</div>
																	</div>
																	<div className="col-lg-5 col-md-4 my-0 my-lg-2 my-md-2 text-right">
																		<button
																			className="flit-btn bt-prof-green pad-zada"
																			onClick={() =>
																				navigate(
																					`/ProductInterestDetails/${item?.vehicle?.id}`,
																				)
																			}
																		>
																			View Details
																		</button>
																		{/* <a
																			href="#"
																			class="flit-btn bt-prof-green pad-zada"
																		></a> */}
																	</div>
																</>
															);
														})}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
						{/* accout section ends*/}
						{/* Footer */}
						<Footer />
						{/* Footer */}
					</div>
				</>
			) : (
				<Spinner />
			)}
		</>
	);
};

export default MyInterests;
